export default function setHasInvalidEmailBeenSent(state, action) {
    const hasInvalidEmailBeenSent =  action.hasInvalidEmailBeenSent;

    return {...state, hasInvalidEmailBeenSent};
}